import React from 'react'
import errorImg from '../../assets/images/newui/error-cross.svg'
import './ErrorBox.less'

const ErrorBox = ({message}) => {
    return <div className='error-box-container'>
        <img src={errorImg}></img>
        <div>{message}</div>
    </div>
}

export default ErrorBox;